import { computed } from "vue";
import { useDisplay } from "vuetify";

export const WORKSPACE_DRAWER_BREAKPOINT = 1280;

export function useWorkspaceDisplay() {
  const display = useDisplay();
  const isWorkspaceDrawerOverlay = computed(() => {
    const width = display.width?.value;
    return typeof width === "number" ? width < WORKSPACE_DRAWER_BREAKPOINT : display.mdAndDown.value;
  });

  return { isWorkspaceDrawerOverlay };
}
